'use client';

import { useEffect, useRef } from 'react';
import { swal } from '../../../../lib';
import { formatCurrency } from '../../../../utils/formatters';
import { scrollIntoTheView } from '../../../../utils/functions';

function PurchaseFinishAlert({
  scrollTargetId,
  purchasedCoin,
}: {
  scrollTargetId: string;
  purchasedCoin: number;
}) {
  const didAlertRef = useRef(false);

  useEffect(() => {
    (async () => {
      if (didAlertRef.current) return;
      didAlertRef.current = true;

      if (purchasedCoin > 0) {
        scrollIntoTheView(scrollTargetId);

        await swal.messages({
          messages: [`購入コイン: ${formatCurrency(purchasedCoin)}`, 'コインの購入が完了しました'],
        });
      }
    })();

    return () => {
      didAlertRef.current = true;
    };
  }, [didAlertRef, purchasedCoin, scrollTargetId]);

  return <></>;
}

export default PurchaseFinishAlert;
